import { number, struct } from 'io-ts/Decoder';

export const Response = struct({
	announcement: number,
	chat: number,
	other: number,
});
